import React, { useEffect } from "react"
import { connect } from "react-redux"
import { Card } from "antd"
import _ from "lodash"

/* custom component */
import { PageContainer, Xpagination } from "../../../component/Xcomponent"
import ArticleBlock from "../../../component/ArticleBlock/ArticleBlock"
// Utils
import "./ContentRepoList.css"
/* actions */
import { getArticleHomeList, getArticleHomeListReset } from "../../../action/getArticleHomeListAction"

const ContentRepo = (props) => {

    /* variables */
    const {
        getArticleHomeList, getArticleHomeListReset, getArticleHomeListState
    } = props


    // Callback
    useEffect(() => {
        getArticleHomeList()
        return (() => {
            getArticleHomeListReset()
        })
    }, [])

    return (
        <PageContainer>
            <Card
                title="Article"
                bordered={true}
                style={{
                    padding: "30px",
                    justifyContent: "center",
                }}
            >

                <div className="container">
                    <div className="Articlecontainer">
                        <ArticleBlock />
                    </div>
                </div>
            </Card >
        </PageContainer >
    )
}

const mapStateToProps = (state) => ({
    getArticleHomeListState: state.getArticleHomeList,
})

const mapDispatchToProps = (dispatch) => ({
    getArticleHomeList: (params) => dispatch(getArticleHomeList(params)),
    getArticleHomeListReset: () => dispatch(getArticleHomeListReset()),
})

export default connect(mapStateToProps, mapDispatchToProps)(ContentRepo)